import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type HeaderComponentProps = {
  children: React.ReactNode
}

const HeaderComponent: React.FC<HeaderComponentProps> = ({ children }) => {
  const classes = useStyles()

  return <div className={clsx(classes.root, 'header')}>{children}</div>
}

export default React.memo(HeaderComponent)
